import React from 'react'

const AttendingToken = (attending) =>(
  <div className="token">
    { attending.name }
  </div>
)

export default AttendingToken
